import React, { useState, useEffect, useRef } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

const AddCenter = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [states, setStates] = useState([])
  const [plants, setPlants] = useState([])
  const [companies, setCompanies] = useState([])
  const [districts, setDistricts] = useState([])
  const [taluks, setTaluks] = useState([])
  const [cows, setCows] = useState([])
  const [buffalos, setBuffalos] = useState([])
  const [common, setCommon] = useState([])
  const [ratechartType, setRatechartType] = useState("")
  const [loadingDistricts, setLoadingDistricts] = useState(false)
  const [loadingTaluks, setLoadingTaluks] = useState(false)
  const [selectedCompany, setSelectedCompany] = useState("")

  useEffect(() => {
    const load = async () => {
      try {
        const [stResp, cowResp, bufResp, comResp, plantResp, compResp] = await Promise.all([
          api.get("states"),
          api.get("rate-chart-type/1"),
          api.get("rate-chart-type/2"),
          api.get("rate-chart-type/3"),
          api.get("plants"),
          api.get("companies")
        ])
        setStates(Array.isArray(stResp.data.data) ? stResp.data.data : stResp.data.data?.data || [])
        setCows(Array.isArray(cowResp.data.data) ? cowResp.data.data : cowResp.data.data?.data || [])
        setBuffalos(Array.isArray(bufResp.data.data) ? bufResp.data.data : bufResp.data.data?.data || [])
        setCommon(Array.isArray(comResp.data.data) ? comResp.data.data : comResp.data.data?.data || [])
        setPlants(Array.isArray(plantResp.data.data) ? plantResp.data.data : plantResp.data.data?.data || [])
        const compData = Array.isArray(compResp.data.data) ? compResp.data.data : compResp.data.data?.data || []
        setCompanies(compData)
        // Auto-select company if only one
        if (compData.length === 1) setSelectedCompany(String(compData[0].id))
      } catch (e) { console.error(e) }
    }
    load()
  }, [])

  const stateChangeHandler = async e => {
    const stateId = e.target.value
    setDistricts([]); setTaluks([])
    if (!stateId) return
    setLoadingDistricts(true)
    try {
      const resp = await api.get("districts/" + stateId)
      setDistricts(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingDistricts(false)
  }

  const districtChangeHandler = async e => {
    const districtId = e.target.value
    setTaluks([])
    if (!districtId) return
    setLoadingTaluks(true)
    try {
      const resp = await api.get("taluks/" + districtId)
      setTaluks(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingTaluks(false)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      // Remove company_id - it's only used for plant filtering, not stored in chilling_centers
      delete values.company_id
      const response = await api.post("create-center", values)
      if (response.data.success) {
        formRef.current.reset()
        setSubmitted(true)
        setDistricts([]); setTaluks([]); setRatechartType("")
        setTimeout(() => setSubmitted(false), 4000)
      }
    } catch (error) {
      console.error(error)
      alert(error.response?.data?.message || error.response?.data?.error || "Failed to add chilling center")
    }
    setLoading(false)
  }

  const hasMultiCompanies = companies.length > 1
  // Filter plants by selected company
  const filteredPlants = hasMultiCompanies && selectedCompany
    ? plants.filter(p => String(p.company_id) === selectedCompany)
    : plants

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Add Chilling Center</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Link to="/chilling-centers" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link>
          </Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm ref={formRef} className="form-horizontal mt-4" onValidSubmit={handleValidSubmit}>

          {/* Center Info */}
          <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px" }}>
            <i className="fas fa-warehouse"></i> Center Information
          </h6>
          <Row>
            {hasMultiCompanies && (
              <Col md={3}><div className="mb-3">
                <AvField type="select" name="company_id" label="Company *" required
                  onChange={e => setSelectedCompany(e.target.value)}>
                  <option value="">Select Company</option>
                  {companies.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}
                </AvField>
              </div></Col>
            )}
            <Col md={hasMultiCompanies ? 3 : 4}><div className="mb-3">
              <AvField type="select" name="plant_id" label="Plant *" required>
                <option value="">Choose a client plant name . . .</option>
                {filteredPlants.map((p, i) => <option key={i} value={String(p.id)}>{p.name}</option>)}
              </AvField>
            </div></Col>
            <Col md={hasMultiCompanies ? 3 : 4}><div className="mb-3">
              <AvField name="name" label="Chilling Center Name *" type="text" required placeholder="Enter Center Name" />
            </div></Col>
            <Col md={hasMultiCompanies ? 3 : 4}><div className="mb-3">
              <AvField name="number" label="Chilling Center Number *" type="text" required placeholder="Enter Center Number" />
            </div></Col>
          </Row>

          {/* Address */}
          <h6 style={{ color: "#0ea5e9", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-map-marker-alt"></i> Address Details
          </h6>
          <Row>
            <Col md={3}><div className="mb-3">
              <AvField name="door" label="Door No" type="text" placeholder="Door No" />
            </div></Col>
            <Col md={3}><div className="mb-3">
              <AvField name="village" label="Village Name" type="text" placeholder="Village Name" />
            </div></Col>
            <Col md={3}><div className="mb-3">
              <AvField name="talukName" label="Taluk Name" type="text" placeholder="Taluk Name" />
            </div></Col>
            <Col md={3}><div className="mb-3">
              <AvField type="select" name="state" label="State" onChange={stateChangeHandler}>
                <option value="">Select State</option>
                {states.map((s, i) => <option key={i} value={String(s.id)}>{s.state}</option>)}
              </AvField>
            </div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="district" label={<>District {loadingDistricts && <Spinner size="sm" color="primary" className="ms-1" />}</>} onChange={districtChangeHandler}>
                <option value="">{loadingDistricts ? "Loading districts..." : districts.length ? "Select District" : "Select State first"}</option>
                {districts.map((d, i) => <option key={i} value={String(d.id)}>{d.district}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField name="pincode" label="Pincode" type="text" placeholder="e.g. 388001"
                validate={{
                  pattern: { value: /^[1-9][0-9]{5}$/, errorMessage: "Enter valid 6-digit pin code" },
                  minLength: { value: 6, errorMessage: "Pin code must be 6 digits" },
                  maxLength: { value: 6, errorMessage: "Pin code must be 6 digits" }
                }} />
            </div></Col>
          </Row>

          {/* App Logins */}
          <h6 style={{ color: "#22c55e", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-mobile-alt"></i> App Login Details
          </h6>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField label="Quality App Remote Login Details" type="textarea" name="qualityAppLogins" rows="3" />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField label="Reception App Remote Login Details" type="textarea" name="remoteAppLogins" rows="3" />
            </div></Col>
          </Row>

          {/* Rate Chart Config */}
          <h6 style={{ color: "#f59e0b", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-chart-line"></i> Rate Chart Configuration
          </h6>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="ccSolutionInstalled" label="Is NextGenDairy CC Solution Installed for this CC? *" required errorMessage="Pick one!">
                <AvRadio label="Yes" value="yes" /><AvRadio label="No" value="no" />
              </AvRadioGroup>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="rateChartVlcc" label="Rate Chart Applicable for VLCC Entry *" required errorMessage="Pick one!">
                <AvRadio label="Common For All Centers" value="Common For All Centers" />
                <AvRadio label="VLCC's Own Rate Chart" value="VLCC's Own Rate Chart" />
                <AvRadio label="Centerwise" value="Centerwise" />
              </AvRadioGroup>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="rateChartBulkVendor" label="Rate Chart Applicable for Bulk Vendor Entry *" required errorMessage="Pick one!">
                <AvRadio label="Common for All Vendors" value="Common for All Vendors" />
                <AvRadio label="Vendorwise" value="Vendorwise" />
              </AvRadioGroup>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="rateChartType" label="Rate Chart Type *" required errorMessage="Pick one!" onChange={e => setRatechartType(e.target.value)}>
                <AvRadio label="Common" value="0" /><AvRadio label="Separate" value="1" />
              </AvRadioGroup>
            </div></Col>
          </Row>
          <Row>
            {ratechartType === "1" ? (<>
              <Col md={6}><div className="mb-3">
                <AvField type="select" name="cowRatechart" label="Cow Milk Ratechart *" required>
                  <option value="">Select Cow Milk Ratechart</option>
                  {cows.map((c, i) => <option key={i} value={c.id}>{c.ratechartName}</option>)}
                </AvField>
              </div></Col>
              <Col md={6}><div className="mb-3">
                <AvField type="select" name="buffaloRatechart" label="Buffalo Milk Ratechart *" required>
                  <option value="">Select Buffalo Milk Ratechart</option>
                  {buffalos.map((b, i) => <option key={i} value={b.id}>{b.ratechartName}</option>)}
                </AvField>
              </div></Col>
            </>) : (
              <Col md={6}><div className="mb-3">
                <AvField type="select" name="bothRatechart" label="Select Common Rate Chart">
                  <option value="">Choose a common rate chart . . .</option>
                  {common.map((c, i) => <option key={i} value={c.id}>{c.ratechartName}</option>)}
                </AvField>
              </div></Col>
            )}
          </Row>

          {/* Sour Milk & Incentives */}
          <h6 style={{ color: "#8b5cf6", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-rupee-sign"></i> Sour Milk & Incentives
          </h6>
          <Row>
            <Col md={12}><div className="mb-3">
              <AvRadioGroup inline name="sourMilkRateType" label="Sour Milk Rate Calculation Type *" required errorMessage="Pick one!">
                <AvRadio label="Flat Rate" value="Flat Rate" />
                <AvRadio label="Use Same Rate Chart as Good Milk" value="Use Same Rate Chart as Good Milk" />
              </AvRadioGroup>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="cowMilkIncentive" label="Cow Milk Incentive/Commission Available? *" required errorMessage="Pick one!">
                <AvRadio label="Not Available" value="Not Available" />
                <AvRadio label="Common for All Vendors/Agents" value="Common for All Vendors/Agents" />
                <AvRadio label="Vendorwise/Agentwise Incentive" value="Vendorwise/Agentwise Incentive" />
              </AvRadioGroup>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="buffaloMilkIncentive" label="Buffalo Milk Incentive/Commission Available? *" required errorMessage="Pick one!">
                <AvRadio label="Not Available" value="Not Available" />
                <AvRadio label="Common for All Vendors/Agents" value="Common for All Vendors/Agents" />
                <AvRadio label="Vendorwise/Agentwise Incentive" value="Vendorwise/Agentwise Incentive" />
              </AvRadioGroup>
            </div></Col>
          </Row>

          {/* Management */}
          <h6 style={{ color: "#ef4444", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-user-tie"></i> Management
          </h6>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField name="managerFields" label="Procurement Manager (Fields)" type="text" placeholder="Enter Manager Name" />
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField name="managerOperations" label="Procurement Manager (Operations)" type="text" placeholder="Enter Manager Name" />
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField name="ccIncharges" label="CC Incharges" type="text" placeholder="Enter CC Incharges" />
            </div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">
              {submitted && <UncontrolledAlert color="success"><strong>Chilling Center Added!</strong></UncontrolledAlert>}
            </div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /><span style={{ paddingLeft: "10px" }}>Adding...</span></> : <span><i className="fas fa-plus-circle"></i> Add Center</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default AddCenter
